function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
import { finectAPI } from '@finect/front-utils/finectAPI';
import { getProductTypeBySlug } from '@finect/front-resources/Products';
import { withSubscriptions } from '@finect/front-core/User';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ProductSummary } from '../../../Products';
import { setProductRequest } from '../actions';
import { Inner } from './partials';
var EXPANDS = {
  collectives: 'classes,stats/performance,stats/standardDeviation,stats/alpha,stats/beta',
  generics: null
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.user.user
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      setProductRequest: setProductRequest
    }, dispatch)
  };
};
var getProduct = function getProduct(subtype, id) {
  var productType = getProductTypeBySlug(subtype);
  var family = productType.category === 'iic' ? 'collectives' : 'generics';
  var path = function path() {
    if (['iic'].includes(productType.category)) {
      return "/products/".concat(family, "/").concat(productType.api, "/").concat(id);
    }
    return "/products/".concat(id);
  };
  var expand = EXPANDS[family] || null;
  return finectAPI({
    version: 'v4',
    path: "".concat(path()).concat(expand ? "?expand=".concat(expand) : ''),
    method: 'GET',
    onSuccess: function onSuccess(_ref) {
      var data = _ref.data;
      return productType.category === 'iic' ? {
        entity: data,
        subtype: productType.apiSubtype
      } : data;
    },
    onError: function onError() {
      return null;
    }
  });
};
var ProductSummaryCard = function (_React$Component) {
  _inherits(ProductSummaryCard, _React$Component);
  var _super = _createSuper(ProductSummaryCard);
  function ProductSummaryCard() {
    var _this;
    _classCallCheck(this, ProductSummaryCard);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      product: null
    });
    _defineProperty(_assertThisInitialized(_this), "handleListFollow", function (product, follow) {
      _this.props.handleEntityFollow('product', 'subscribe', product, follow);
    });
    _defineProperty(_assertThisInitialized(_this), "handleFollow", function (follow) {
      _this.props.handleEntityFollow('product', 'subscribe', _this.state.product, follow);
    });
    _defineProperty(_assertThisInitialized(_this), "handleProductRequest", function () {
      _this.props.actions.setProductRequest(_this.state.product);
    });
    return _this;
  }
  _createClass(ProductSummaryCard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var _this$props = this.props,
        subtype = _this$props.subtype,
        id = _this$props.id;
      getProduct(subtype, id).then(function (product) {
        _this2.setState({
          product: product
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var product = this.state.product;
      if (product) {
        return React.createElement(Inner, null, React.createElement("div", null, React.createElement(ProductSummary, {
          user: this.props.user,
          product: product,
          productsSubscriptions: this.props.subscriptions.products,
          actions: {
            onProductSubscription: this.props.handleEntityFollow
          },
          twoColumns: true,
          isOnArticle: true,
          withManager: true
        })));
      }
      return null;
    }
  }]);
  return ProductSummaryCard;
}(React.Component);
export default withSubscriptions(connect(mapStateToProps, mapDispatchToProps)(ProductSummaryCard), ['products', 'profiles']);